import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  NgZone,
  OnChanges,
} from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { SafeUrlService } from '@merchant-portal/app/services/safe-url.service';
import { UtilService } from '@merchant-portal/app/services/util.service';

@Component({
  selector: 'app-svg-loader',
  templateUrl: './svg-loader.component.html',
  styleUrls: ['./svg-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SvgLoaderComponent implements OnChanges {
  private safeUrlService = inject(SafeUrlService);
  private utilService = inject(UtilService);
  private ngZone = inject(NgZone);
  private cdr = inject(ChangeDetectorRef);

  assetPath = 'assets/icon/';
  @Input() url = '';

  isLoading = false;
  isExternal = false;
  svgUrl = '';
  externalUrl: SafeUrl = '';

  ngOnChanges(): void {
    this.processUrl();
  }

  private processUrl(): void {
    if (!this.url) {
      this.isExternal = false;
      this.svgUrl = '';
      this.cdr.markForCheck();
      return;
    }

    this.isExternal = this.utilService.isExternalLogoUrl(this.url);

    if (this.isExternal) {
      this.isLoading = true;
      this.externalUrl = this.safeUrlService.sanitizeUrl(this.url);

      setTimeout(() => {
        this.ngZone.run(() => {
          this.isLoading = false;
          this.cdr.markForCheck();
        });
      }, 3000);
    } else {
      this.svgUrl = this.url;
    }
    this.cdr.markForCheck();
  }

  onImageLoad(): void {
    this.ngZone.run(() => {
      this.isLoading = false;
      this.cdr.markForCheck();
    });
  }

  onImageError(): void {
    this.ngZone.run(() => {
      this.isLoading = false;
      this.cdr.markForCheck();
    });
  }
}
